import { render, staticRenderFns } from "./YesNoType.vue?vue&type=template&id=40c35220&"
import script from "./YesNoType.vue?vue&type=script&lang=ts&"
export * from "./YesNoType.vue?vue&type=script&lang=ts&"
import style0 from "./YesNoType.vue?vue&type=style&index=0&id=40c35220&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports